import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import "./style.css"

import { setupAxios } from './setupAxios';

ReactDOM.render(<App />, document.getElementById("root"))